export const COUNTRY_BLOCKER_COUNTRY_IN_UNFINISHED_AUCTION = 'country.blocker.countryInUnfinishedAuction';
export const COUNTRY_BLOCKER_USED_IN_AUCTION = 'usedInAuction';

export const transformCountryDeactivationBlockers = (t, blockerKey) => {
    let result;
    if (blockerKey === COUNTRY_BLOCKER_COUNTRY_IN_UNFINISHED_AUCTION) {
        result = t('countries.blocker.deactivation.country-in-unfinished-auction');
    } else {
        throw new Error(`Unknown blocker key: ${blockerKey}`);
    }
    return result;
};

export const transformCountryModificationBlockers = (t, blockerKey) => {
    let result;
    if (blockerKey === COUNTRY_BLOCKER_USED_IN_AUCTION) {
        result = t('countries.blocker.modification.used-in-auction');
    } else {
        throw new Error(`Unknown blocker key: ${blockerKey}`);
    }
    return result;
};
